import WidgetTypes from './widget-types'
import i18n from 'live/services/i18n'
import ptBr from './i18n/pt_br'
import enUs from './i18n/en_us'
import serviceLocator from 'live/services/service-locator'
import api from './lib/api'
import './styles.scss'
import '../shared'
import { LiveApi } from 'live/lib/api'

const locale = Live.settings && Live.settings.locale ? Live.settings.locale : 'en_us'
const localeFiles = {
    pt_br: ptBr,
    en_us: enUs
}

i18n.add(localeFiles[locale])

WidgetTypes.setup()

serviceLocator.registerService('plugin-liverig-vis:api', api)